import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { logoBase64 } from "@/utils/reusables/pdfLogo";
import { inject } from "vue";

export default function pdfGenerateHandler() {
  const moment = inject("$moment");
  const exportPDF = (invoice, amount) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    // Logo (centered)
    const logoWidth = 85;
    const logoHeight = 20;
    const logoX = (pageWidth - logoWidth) / 2;
    doc.addImage(logoBase64, "PNG", logoX, 10, logoWidth, logoHeight);

    // Title (centered)
    const title = "PAYMENT REQUEST";
    const titleWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - titleWidth) / 2;
    doc.setFontSize(18);
    doc.text(title, titleX, 40);

    // Info rows (left and right aligned)
    doc.setFontSize(11);
    // Row 1
    doc.text(`Payee Name: ${invoice.paymentpayee}`, 10, 58);
    doc.text(
      `Date of Request: ${moment(invoice.paymentdate).format("LL") || "July 03, 2025"}`,
      pageWidth - 10,
      58,
      { align: "right" }
    );
    // Row 2
    doc.text(`Transaction Number: ${invoice.transactionnumber}`, 10, 68);
  

    // Summary Details title
    doc.setFont("helvetica", "bold");
    doc.text("Summary Details", 10, 90);
    doc.setFont("helvetica", "normal"); // reset to normal for table

    // Bordered table
    autoTable(doc, {
      startY: 94,
      margin: { left: 10, right: 10 },
      theme: "grid",
      body: [
        ["Payment Channel:", invoice.paymentprovider],
        ["Account Number:", invoice.paymentaccount],
        ["Reimbursable Amount", amount || "PHP 0.00"],
      ],
      styles: {
        fontSize: 9,
        textColor: [40, 40, 40],
        cellPadding: 3,
        lineWidth: 0.1,
        lineColor: [200, 200, 200],
      },
      bodyStyles: {
        textColor: [60, 60, 60],
        fillColor: false,
      },
    });

    // Total (right-aligned)
    const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 120;
    doc.setFontSize(14);
    const totalText = `Total: ${amount || "PHP 0.00"}`;
    doc.text(totalText, pageWidth - 10, finalY, { align: "right" });

    // Prepared by
  


    
    // Save PDF
    doc.save(`${invoice.transactionnumber}.pdf`);
  };

  return {
    exportPDF,
  };
}
